import { Route, Routes } from 'react-router-dom'
import RequireRole from '../../common/components/RequireRole'
import { BackofficePermissionsEnum as Permissions } from '../../common/enums/backOfficePermissionsEnum'
import { ConfigFunds } from '../../modules/funds/ConfigFunds'
import { Funds } from '../../modules/funds/Funds'
import { RecommendedFunds } from '../../modules/funds/RecommendedFunds'
import { ConfigFunds as ConfigFundsv2 } from '../../modules/funds/v2/ConfigFunds'
import { Funds as Fundsv2 } from '../../modules/funds/v2/Funds'
import { RecommendedFundsConfig } from '../../modules/funds/v2/RecommendedFundsConfig'
import { SuspensedView } from '../PrivateRoutes'

export const FundsRouting = () => {
  return (
    <Routes>
      <Route
        path='list'
        element={
          <RequireRole roles={Permissions.FUND.LIST}>
            <SuspensedView>
              <Funds />
            </SuspensedView>
          </RequireRole>
        }
      />
      <Route
        path='list-v2'
        element={
          <RequireRole roles={Permissions.FUND.LIST}>
            <SuspensedView>
              <Fundsv2 />
            </SuspensedView>
          </RequireRole>
        }
      />
      <Route
        path='recommended'
        element={
          <RequireRole roles={Permissions.FUND.RECOMMENDED}>
            <SuspensedView>
              <RecommendedFunds />
            </SuspensedView>
          </RequireRole>
        }
      />
      <Route
        path='recommended-config'
        element={
          <RequireRole roles={Permissions.FUND.RECOMMENDED}>
            <SuspensedView>
              <RecommendedFundsConfig />
            </SuspensedView>
          </RequireRole>
        }
      />
      <Route
        path='config/:id'
        element={
          <RequireRole roles={Permissions.FUND.UPDATE}>
            <SuspensedView>
              <ConfigFunds />
            </SuspensedView>
          </RequireRole>
        }
      />
      <Route
        path='config-v2/:id'
        element={
          <RequireRole roles={Permissions.FUND.UPDATE}>
            <SuspensedView>
              <ConfigFundsv2 />
            </SuspensedView>
          </RequireRole>
        }
      />
    </Routes>
  )
}
